import { LocalesEnum } from './enums/LocalesEnum';
import { LocalizedAttributesValueInterface } from './interfaces/LocalizedAttributesValueInterface';

export const createIsCompetitor = <
    L extends LocalizedAttributesValueInterface,
    C extends Record<any, L | null>,
    F extends keyof C,
>(field: F): (
    attributes: C,
    rawName: LocalesEnum,
) => boolean => {
    return (
        attributes: C,
        rawName: LocalesEnum,
    ): boolean => {
        return attributes[field]
            && attributes[field] !== null
            && attributes[field]?.[rawName] !== undefined
            && Array.isArray(attributes[field]![rawName])
            && attributes[field]![rawName]!.every((item) => item === '1');
    }
}
